// extracted by mini-css-extract-plugin
export default {"routineHistory":"routineHistory-pJEsw","routineList":"routineList-f8VMM","controls":"controls-_p9yc","option":"option-SlLfo"};